const AWAIT_UNLOCK_DELAY = 100

let lock = false
let lockResult: 'fail' | undefined = undefined

export const checkNeedRefreshToken = async (
  refresher: () => Promise<boolean>,
): Promise<boolean> => {
  console.log('🔏 REQUEST CHECK')
  const checkId = Date.now()
  if (!lock) {
    console.log('🔏 REQUEST LOCK', checkId)
    lock = true
    lockResult = undefined
    try {
      const result = await refresher()
      if (!result) {
        lockResult = 'fail'
        return false
      }
    } catch (e: any) {
      console.error('🔏 ANY ERROR', e)
      lockResult = 'fail'
      return false
    } finally {
      console.log('🔏 REQUEST UNLOCK', checkId)
      lock = false
    }
    lockResult = undefined
    return true
  }
  do {
    console.log('🔏 REQUEST CHECK ---WAITING---')
    await delay(AWAIT_UNLOCK_DELAY)
  } while (lock)
  console.log('🔏 REQUEST CHECK RESULT', 'refreshed (after wait)')
  return lockResult !== 'fail'
}

const delay = async (mills: number) => {
  return new Promise<any>((resolve) => {
    setTimeout(resolve, mills)
  })
}
